const licenseLookup = {
  'https://creativecommons.org/licenses/by/2.0/': 'CC-BY-2.0',
  'https://creativecommons.org/licenses/by/3.0/au/': 'CC-BY-3.0',
  'https://creativecommons.org/licenses/by/3.0/ec/': 'CC-BY-3.0',
  'https://creativecommons.org/licenses/by/4.0/': 'CC-BY-4.0',
  'https://www.donneesquebec.ca/fr/licence/#cc-by': 'CC-BY-4.0',
  'https://creativecommons.org/publicdomain/zero/1.0/': 'CC0-1.0',
  'https://opendefinition.org/licenses/odc-pddl/': 'ODC-PDDL',
  'https://opendefinition.org/licenses/odc-odbl/': 'ODC-OBL',
  'https://opendefinition.org/licenses/odc-odbl/1-0/': 'ODBL-1.0',
  'https://opendatacommons.org/licenses/odbl/1-0/': 'ODBL-1.0',
  'https://opendefinition.org/licenses/odc-odbl': 'ODC-OBL',
  'https://creativecommons.org/licenses/by/3.0/ec/ ': 'CC-BY-3.0',
  'http://opendatacommons.org/licenses/pddl/1.0/': 'PDDL',
  'https://opendatacommons.org/licenses/pddl/1.0/': 'PDDL',
  'https://opendatacommons.org/licenses/pddl/1-0/': 'PDDL',
  'https://creativecommons.org/licenses/by/4.0/legalcode': 'CC-BY-4.0',
  'https://creativecommons.org/licenses/by-sa/4.0/': 'CC-BY-SA-4.0',
  'https://creativecommons.org/licenses/by-sa/4.0/deed.es': 'CC-BY-SA-4.0',
  'https://datos.gob.mx/libreusomx': 'LIBREUSOMX',
  'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/': 'OGL-3',
  'http://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/': 'OGL-3',
  'https://www.nationalarchives.gov.uk/doc/open-government-licence/version/2/': 'OGL-2',
  'http://www.nationalarchives.gov.uk/doc/open-government-licence/version/2/': 'OGL-2',
  'https://www.zppa.org.zm/ocds-license': 'PDDL',
  'https://creativecommons.org/licenses/by-nc-sa/4.0/': 'CC-BY-NC-SA-4.0'
}

export { licenseLookup }
